export const getErrorState = (state) => state.debugState.errors;
